import { useState } from 'react';
import IncomeFields from '../IncomeFields';
import IncomeSummary from '../IncomeSummary/';

import type { Income } from '../IncomeCalculator';
import type { FrequencyType } from '../../../common/enums/FrequencyTypes';
import type { IncomeType } from '../../../common/enums/IncomeTypes';
import { DateObject } from '../IncomeFields/IncomeFields';

type Props = {
  id: string;
  editing: boolean;
  incomeType: IncomeType;
  incomeTypeIndex: number | null | undefined;
  incomeFrequency: FrequencyType;
  amount: string;
  startDate?: DateObject;
  endDate?: DateObject;
  calculatedTotal: number;
  onUpdateIncomeEntry: (incomeState: Income, id: string) => void;
  onRemoveIncome: (id: string) => void;
};

const IncomeRow = (props: Props) => {
  const [editing, setEditing] = useState<boolean>(props.editing);

  const handleDoneClick = (incomeState: Income) => {
    props.onUpdateIncomeEntry(incomeState, props.id);
    setEditing(false);
  };

  const handleCancelClick = () => {
    setEditing(false);
  };

  return (
    <>
      {editing ? (
        <IncomeFields
          incomeType={props.incomeType}
          amount={props.amount}
          startDate={props.startDate}
          endDate={props.endDate}
          incomeFrequency={props.incomeFrequency}
          onCancelAddIncome={handleCancelClick}
          onDoneClick={handleDoneClick}
        />
      ) : (
        <IncomeSummary
          onEditClick={() => setEditing(true)}
          amount={props.amount}
          incomeType={props.incomeType}
          incomeTypeIndex={props.incomeTypeIndex}
          incomeFrequency={props.incomeFrequency}
          calculatedTotal={props.calculatedTotal}
          startDate={props.startDate}
          endDate={props.endDate}
          onRemoveIncome={() => props.onRemoveIncome(props.id)}
        />
      )}
    </>
  );
};

export default IncomeRow;
